// S-04 tabs (Frontend §7.1, in its order). Task 03 builds Summary and Connection, task 10 Errors, task 11 Health,
// task 12 Users, task 13 Activity, task 16 Protection.
export const CLINIC_TABS = ['summary', 'users', 'connection', 'protection', 'health', 'errors', 'activity'] as const
export type ClinicTab = (typeof CLINIC_TABS)[number]

export const isClinicTab = (tab: string): tab is ClinicTab => (CLINIC_TABS as readonly string[]).includes(tab)

export const TAB_LABELS: Record<ClinicTab, string> = {
  summary: 'Summary',
  users: 'Users',
  connection: 'Connection',
  protection: 'Protection',
  health: 'Health',
  errors: 'Errors',
  activity: 'Activity',
}
